export const ping = () => ({
    url: 'tests/ping',
    method: 'get',
});

export const testHumanVerification = () => ({
    url: 'tests/humanverification',
    method: 'get',
});
